export const getMinimalRatingQueryParam = (rating: number): string => {
  const ratingValues = [1, 2, 3, 4, 5];
  const minimalValues = ratingValues.filter((value) => value >= rating);

  return minimalValues.join(',');
};
